import { render, staticRenderFns } from "./NavExpandItem.vue?vue&type=template&id=4863b0f3&scoped=true"
import script from "./NavExpandItem.vue?vue&type=script&lang=ts"
export * from "./NavExpandItem.vue?vue&type=script&lang=ts"
import style0 from "./NavExpandItem.vue?vue&type=style&index=0&id=4863b0f3&prod&lang=scss&scoped=true"
import style1 from "./NavExpandItem.vue?vue&type=style&index=1&id=4863b0f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4863b0f3",
  null
  
)

export default component.exports